<div class="detail-inventaire-modal">
    <div *ngIf="isLoading" class="text-center p-4">
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Chargement...</span>
        </div>
    </div>

    <div *ngIf="!isLoading" class="detail-inventaire-tab-panel">
        <div class="detail-inventaire-table-scroll">
            <table class="styled-table w-full detail-inventaire-lines products-table detail-articles-table">
                <colgroup>
                    <col class="detail-col-code-barre" />
                    <col class="detail-col-designation" />
                    <col class="detail-col-qty" />
                    <col class="detail-col-remise" />
                    <col class="detail-col-price" />
                    <col class="detail-col-price" />
                </colgroup>
                <thead>
                <tr class="detail-inventaire-articles-thead-row">
                    <th class="detail-th-code-barre">CODE À BARRE</th>
                    <th class="detail-th-produit">PRODUIT</th>
                    <th class="detail-th-num detail-th-qty">QUANTITÉ</th>
                    <th class="detail-th-num detail-th-remise">REMISE</th>
                    <th class="detail-th-num detail-th-price">{{ getDetailFirstPriceLabel() }}</th>
                    <th class="detail-th-num detail-th-price">{{ getDetailSecondPriceLabel() }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="lignesDocument.length === 0">
                    <td [attr.colspan]="detailTableColspan" class="text-center text-muted">Aucun article</td>
                </tr>
                <ng-container *ngFor="let ligne of lignesDocument; let i = index">
                    <ng-container *ngIf="isProductLineVisible(i)">

                        <tr *ngIf="shouldShowProductLineRefOpenSummary(i)"
                            class="document-product-line__group-header-row document-product-line__group-header-row--ref">
                            <td class="document-product-line__group-header-cell detail-th-code-barre"></td>
                            <td class="document-product-line__group-header-cell">
                                <div class="detail-group-inline detail-group-inline--ref"
                                     (click)="toggleProductLineBarcodeGroup(i, $event)">
                                    <button type="button"
                                            class="document-barcode-group-toggle"
                                            (click)="toggleProductLineBarcodeGroup(i, $event)"
                                            [attr.aria-expanded]="true"
                                            title="Replier le groupe réf. fabricant">
                                        <i data-feather="chevron-right"
                                           class="feather-16 document-barcode-group-toggle__icon--open"></i>
                                    </button>
                                    <span class="detail-group-inline__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                    <span class="detail-group-inline__stats">
                                        <span class="detail-group-inline__stat">
                                            {{ getProductLineGroupCouleurCount(i) }} couleur{{ getProductLineGroupCouleurCount(i) > 1 ? 's' : '' }}
                                        </span>
                                        <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                            {{ getProductLineGroupBarcodeCount(i) }} variante{{ getProductLineGroupBarcodeCount(i) > 1 ? 's' : '' }}
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td [attr.colspan]="getProductLineRefOpenBannerTrailingColspan()"
                                class="document-product-line__group-header-cell"></td>
                        </tr>

                        <tr *ngIf="shouldShowProductLineSplitLayout(i) && shouldShowProductLineCouleurBannerRow(i)"
                            class="document-product-line__group-header-row document-product-line__group-header-row--couleur">
                            <td class="document-product-line__group-header-cell detail-td-code-barre"></td>
                            <td class="document-product-line__group-header-cell">
                                <div class="detail-group-inline detail-group-inline--couleur">
                                    <button type="button"
                                            class="document-barcode-group-toggle document-barcode-group-toggle--couleur"
                                            *ngIf="productLineCouleurGroupCanToggle(i)"
                                            (click)="toggleProductLineCouleurGroup(i, $event)"
                                            [attr.aria-expanded]="isProductLineCouleurGroupExpanded(i)"
                                            [title]="isProductLineCouleurGroupExpanded(i) ? 'Masquer les produits de cette couleur' : 'Afficher les produits de cette couleur'">
                                        <i data-feather="chevron-right"
                                           class="feather-16"
                                           [class.document-barcode-group-toggle__icon--open]="isProductLineCouleurGroupExpanded(i)"></i>
                                    </button>
                                    <span class="detail-group-inline__couleur">{{ getProductLineCouleurNorm(i) }}</span>
                                    <span class="detail-group-inline__stats">
                                        <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                            {{ getProductLineCouleurBarcodeCount(i) }} variante{{ getProductLineCouleurBarcodeCount(i) > 1 ? 's' : '' }}
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td [attr.colspan]="getProductLineRefOpenBannerTrailingColspan()"
                                class="document-product-line__group-header-cell"></td>
                        </tr>

                        <tr class="document-product-line__data-row"
                            [class.document-product-line--variant-row]="isProductLineVariantProductRow(i)"
                            [class.document-product-line--ref-collapsed]="isProductLineRefGroupCollapsedHead(i)"
                            [class.document-product-line--couleur-collapsed]="isProductLineCouleurGroupCollapsedHead(i)">
                            <td class="detail-td-code-barre">
                                <ng-container *ngIf="shouldShowProductLineBarcodeCell(i); else barcodeGroupCollapsedHint">
                                    <span class="detail-code-barre-readonly"
                                          [title]="formatBarcodeDisplay(ligne.code_barre)">{{ formatBarcodeDisplay(ligne.code_barre) }}</span>
                                </ng-container>
                                <ng-template #barcodeGroupCollapsedHint></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="isProductLineRefGroupCollapsedHead(i)">
                                    <div class="detail-group-inline detail-group-inline--ref detail-group-inline--clickable"
                                         (click)="toggleProductLineBarcodeGroup(i, $event)">
                                        <button type="button"
                                                class="document-barcode-group-toggle"
                                                (click)="toggleProductLineBarcodeGroup(i, $event)"
                                                [attr.aria-expanded]="false"
                                                title="Afficher par couleur">
                                            <i data-feather="chevron-right" class="feather-16"></i>
                                        </button>
                                        <span class="detail-group-inline__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                        <span class="detail-group-inline__stats">
                                            <span class="detail-group-inline__stat">
                                                {{ getProductLineGroupCouleurCount(i) }} couleur{{ getProductLineGroupCouleurCount(i) > 1 ? 's' : '' }}
                                            </span>
                                            <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                {{ getProductLineGroupBarcodeCount(i) }} variante{{ getProductLineGroupBarcodeCount(i) > 1 ? 's' : '' }}
                                            </span>
                                        </span>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="isProductLineCouleurGroupCollapsedHead(i)">
                                    <div class="detail-group-inline detail-group-inline--couleur detail-group-inline--clickable"
                                         (click)="toggleProductLineCouleurGroup(i, $event)">
                                        <button type="button"
                                                class="document-barcode-group-toggle document-barcode-group-toggle--couleur"
                                                (click)="toggleProductLineCouleurGroup(i, $event)"
                                                [attr.aria-expanded]="false"
                                                title="Afficher les produits de cette couleur">
                                            <i data-feather="chevron-right" class="feather-16"></i>
                                        </button>
                                        <span class="detail-group-inline__couleur">{{ getProductLineCouleurNorm(i) }}</span>
                                        <span class="detail-group-inline__stats">
                                            <span class="detail-group-inline__stat detail-group-inline__stat--muted">
                                                {{ getProductLineCouleurBarcodeCount(i) }} variante{{ getProductLineCouleurBarcodeCount(i) > 1 ? 's' : '' }}
                                            </span>
                                        </span>
                                    </div>
                                </ng-container>

                                        <ng-container *ngIf="shouldShowProductLineDesignationLeaf(i)">
                                    <div class="document-product-line__desig-row document-product-line__desig-row--editor detail-product-leaf">
                                        <span class="detail-product-leaf__line">
                                            <span class="detail-product-leaf__title">{{ getProductLineRefFabricantLabel(i) }}</span>
                                            <ng-container *ngIf="formatCouleurTailleLine(i)">
                                                <span class="detail-product-leaf__sep" aria-hidden="true">·</span>
                                                <span class="detail-product-leaf__attrs">{{ formatCouleurTailleLine(i) }}</span>
                                            </ng-container>
                                        </span>
                                    </div>
                                </ng-container>
                            </td>
                            <td class="detail-td-num detail-td-qty">{{ getProductLineQuantityDisplay(i) }}</td>
                            <td class="detail-td-num detail-td-remise">{{ getProductLineRemiseDisplay(i) }}</td>
                            <td class="detail-td-num detail-td-price">
                                <ng-container *ngIf="getProductLinePrixUnitaireDisplay(i) as prixA">
                                    <ng-container *ngIf="prixA === '—'; else prixAvecDevise">{{ prixA }}</ng-container>
                                    <ng-template #prixAvecDevise>{{ prixA }} TND</ng-template>
                                </ng-container>
                            </td>
                            <td class="detail-td-num detail-td-price">
                                <ng-container *ngIf="getProductLinePrixVenteDisplay(i) as prixV">
                                    <ng-container *ngIf="prixV === '—'; else prixVAvecDevise">{{ prixV }}</ng-container>
                                    <ng-template #prixVAvecDevise>{{ prixV }} TND</ng-template>
                                </ng-container>
                            </td>
                        </tr>

                    </ng-container>
                </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
